import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    darken,
    IconButton,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    withStyles,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { REALTIME_INTERVAL_SECONDS } from '../../../constants';
import { GisInformationPointsModal } from './GisInformationPointsModal';
import { dataAxureFetch } from '../../../helpers/fetch';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: darken(theme.palette.primary.main, 0.2),
        color: theme.palette.common.white,
        padding: '10px',
    },
    body: {
        fontSize: 18,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: 240,
    },
});

export const GisInformation = ({ filters,getDataToggle,realtime }) => {
    const classes = useStyles();
    const [dataTableInformation, setDataTableInformation] = useState({});
    const [dataTablePoints, setDataTablePoints] = useState([])
    
    const uid = useSelector((state) => state.auth.uid);
    const uptws = useSelector((state) => state.auth.ptws);

    /**
     * Allow to change if real time or not, charge data
     */
    useEffect(() => {
        if (!realtime) {
            return;
        }
        getData();
        let unmounted = false;
        const interval = setInterval(() => {
            if(!unmounted){
                getData();
            }
        }, REALTIME_INTERVAL_SECONDS * 1000);
        return () => {
            if (!realtime) {
                return;
            }
            unmounted= true
            clearInterval(interval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Charge data for the historicScreen
     */
    useEffect(() => {
        if (getDataToggle) {
            getDataHistoric();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getDataToggle]);


    /**
     * To get data from de differents json 
     */
    const getData = async () => {
        try {
            const responseTotalPoints = await dataAxureFetch({solicitud:"CtdPuntos",idCliente:uid,ptws:uptws},'POST');
            const responseTotalAlerts = await dataAxureFetch({solicitud:"CtdAlertas",idCliente:uid,ptws:uptws},'POST'); 
            const responseTotalPointsActives = await dataAxureFetch({solicitud:"NomPuntosAlert",idCliente:uid,ptws:uptws},'POST');
            const response4 = (responseTotalPointsActives===null)? 0 : responseTotalPointsActives.length;

            const response = {
                points: responseTotalPoints[0].total,
                alerts: responseTotalAlerts[0].total,
                monitoring: response4,
            };
            setDataTableInformation(response);

            if(responseTotalPointsActives!==null){
                setDataTablePoints(responseTotalPointsActives.pop().nv_alar_hora)
            }

        } catch (error) {
            console.log(error);
        }
    };

    /**
     * To get data for historicScreen
     */
    const getDataHistoric = async() =>{
        const responseHistoric = await dataAxureFetch(
            {
                nomHRT: filters.pointName,
                idCliente: uid,
                fecIHRT: filters.startDate,
                fecFHRT: filters.endDate,
            },
            'POST'
        );
        
        const response = {
            points: 1,
            alerts: responseHistoric.total_alertas[0].total_alertas,
            monitoring: 1,
        }

        if(response){
            setDataTableInformation(response);
        }
    }

    

    const [activePoints, setActivePoints] = useState(false)

    /**
     * To open modal
     * @param {Event} e 
     */
    const handleClickPoints = (e) =>{
        setActivePoints(true)
    }

    let numberPoints = dataTableInformation.monitoring - 1
    
    if(numberPoints<=-1){
        numberPoints = 0
    }else{
        numberPoints = dataTableInformation.monitoring - 1
    }

    return (
        <TableContainer component={Paper} style={{overflowY:'hidden'}}>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="left">TWS Monitoreados</StyledTableCell>
                        <StyledTableCell align="center">Total Alertas</StyledTableCell>
                        {realtime && 
                            <StyledTableCell align="right">Ultimas Activas</StyledTableCell>
                        }                        
                    </TableRow>
                </TableHead>
                <TableBody>
                    <StyledTableRow>
                        <StyledTableCell align="left">
                            {dataTableInformation.points}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                            {dataTableInformation.alerts}
                            
                        </StyledTableCell>
                        {realtime &&
                            (<StyledTableCell align="right">

                            {
                                (numberPoints!==0)
                                ?(
                                    <IconButton onClick={handleClickPoints}>
                                        <ArrowDropDownIcon/>
                                        <GisInformationPointsModal 
                                            openModal={activePoints} 
                                            closeModal={()=>setActivePoints(false)}
                                            data={dataTablePoints}
                                        />
                                    </IconButton>
                                ):<div>
                                    -
                                </div>
                            }
                            </StyledTableCell>)
                        }
                        
                    </StyledTableRow>
                </TableBody>
            </Table>

        </TableContainer>
    );
};

GisInformation.propTypes = {
    filters: PropTypes.object,
    getDataToggle: PropTypes.bool,
    realtime: PropTypes.bool.isRequired,
}
